export const PROFILE_GET = 'PROFILE_GET'
export const PROFILE_GET_ALL = 'PROFILE_GET_ALL'
export const PROFILE_GET_REPOS = 'PROFILE_GET_REPOS'
export const PROFILE_UPDATE = 'PROFILE_UPDATE'
export const PROFILE_ERROR = 'PROFILE_ERROR'
export const PROFILE_CLEAR = 'PROFILE_CLEAR'

export const ACCOUNT_DELETE = 'ACCOUNT_DELETE'
